import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Box,
  Button,
  InputAdornment,
  IconButton,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { StyledTextField } from './StyledTextField'; // Ajuste o caminho

function PasswordResetForm({ passwordData, onPasswordChange, onUpdatePassword }) {
  const [showPasswords, setShowPasswords] = useState({ new: false, confirm: false });

  const toggleShowNewPassword = () =>
    setShowPasswords((prev) => ({ ...prev, new: !prev.new }));
  const toggleShowConfirmPassword = () =>
    setShowPasswords((prev) => ({ ...prev, confirm: !prev.confirm }));

  return (
    <Card sx={{ bgcolor: '#2C2C2F', color: '#fff', borderRadius: 3 }}>
      <CardHeader title="Redefinir Senha" sx={{ borderBottom: '1px solid #444' }} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <StyledTextField
              fullWidth
              required
              label="Nova Senha"
              name="newPassword"
              value={passwordData.newPassword}
              onChange={onPasswordChange}
              type={showPasswords.new ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={toggleShowNewPassword}
                      edge="end"
                      sx={{ color: '#9e9e9e' }}
                    >
                      {showPasswords.new ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <StyledTextField
              fullWidth
              required
              label="Confirmar Senha"
              name="confirmPassword"
              value={passwordData.confirmPassword}
              onChange={onPasswordChange}
              type={showPasswords.confirm ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={toggleShowConfirmPassword}
                      edge="end"
                      sx={{ color: '#9e9e9e' }}
                    >
                      {showPasswords.confirm ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Button variant="contained" onClick={onUpdatePassword} color="primary">
            Alterar Senha
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default PasswordResetForm;
